export {default as Medical} from './Home';
export {default as MedicalLogin} from './Login';
export {default as ItemEntry} from './ItemEntry';
export {default as ItemIssue} from './ItemIssue';
export {default as ItemReceive} from './ItemReceive';
export {default as IssueReport} from './IssueReport';
export {default as MonthlyIssueRegister} from './MonthlyIssueRegister';
export {default as FirstMovingItems} from './FirstMovingItems';
export {default as MedicalDashboard} from './Dashboard';
export {default as UserSettingsMEDICAL} from '../dashboard/UserSettings';
